import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import { ProjectsList } from "../../components";
import { useApi } from "../../context/context";

function Projects() {
  const { projects } = useApi();
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h1" color="primary.main">
        {t("projects")}
      </Typography>
      <ProjectsList projects={projects} />
    </>
  );
}

export default Projects;
